import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { fetchTimeZoneSetting } from '../api';

const TimeZoneContext = createContext({
  timeZone: 'UTC',
  setTimeZone: () => {},
  isLoadingTimeZone: false,
  refreshTimeZone: async () => {}
});

const TimeZoneProvider = ({ children }) => {
  const [timeZone, setTimeZone] = useState('UTC');
  const [isLoadingTimeZone, setIsLoadingTimeZone] = useState(false);

  const refreshTimeZone = useCallback(async () => {
    setIsLoadingTimeZone(true);
    try {
      const result = await fetchTimeZoneSetting();
      if (result?.timeZone) {
        setTimeZone(result.timeZone);
      }
    } catch (error) {
      console.warn('Failed to load time zone setting.', error);
    } finally {
      setIsLoadingTimeZone(false);
    }
  }, []);

  useEffect(() => {
    refreshTimeZone();
  }, [refreshTimeZone]);

  const value = useMemo(
    () => ({
      timeZone,
      setTimeZone,
      isLoadingTimeZone,
      refreshTimeZone
    }),
    [timeZone, isLoadingTimeZone, refreshTimeZone]
  );

  return <TimeZoneContext.Provider value={value}>{children}</TimeZoneContext.Provider>;
};

export { TimeZoneContext, TimeZoneProvider };
